import { DashboardBody } from "../components/DashboardBody";
import { useContext, useEffect } from "react";
import { MainContext } from "../../../main/context/MainContextProvider";
import { Box } from "@mui/material";
import { usersApi } from "../../../services/api";

export default function Dashboard() {
  const { bodyWidth, user, setUser } = useContext(MainContext);

  async function getUser() {
    if (user) {
      const response = await usersApi.getUser(user?.userId)

      let updatedUser = user;
      updatedUser.resetLayout = response.resetLayout ?? false

      setUser(updatedUser)
    }
  }

  useEffect(() => {
    getUser()
  }, [])

  return (
    <Box
      style={{
        paddingBottom: 60,
        paddingLeft: "24px",
        paddingRight: "24px",
        width: "100%",
        transition: "width 0.2s",
        height: "100%",
      }}
    >
      <DashboardBody bodyWidth={bodyWidth} />
    </Box>
  );
}
